<template>
  <div class="station-navigation">
    <h3 class="section-title">Stations</h3>
    <div class="station-list">
      <button
        v-for="station in stations"
        :key="station.id"
        @click="$emit('station-select', station.id)"
        class="station-btn"
        :class="getStationClass(station)"
      >
        <div class="station-status">
          <span class="station-icon">{{ getStationIcon(station) }}</span>
        </div>
        <div class="station-details">
          <div class="station-name">{{ station.name }}</div>
          <div class="station-meta">Duration: {{ formatDuration(station.duration) }}</div>
        </div>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    stations: Array,
    currentStationId: Number,
    completionStatus: Object
  },
  
  methods: {
    getStationClass(station) {
      const classes = [];
      if (station.id === this.currentStationId) classes.push('active');
      if (this.completionStatus[station.id]?.completed) classes.push('completed');
      if (this.completionStatus[station.id]?.visited) classes.push('visited');
      return classes.join(' ');
    },
    
    getStationIcon(station) {
      if (station.id === this.currentStationId) return '📍';
      if (this.completionStatus[station.id]?.completed) return '✅';
      if (this.completionStatus[station.id]?.visited) return '📝';
      return '⚪';
    },
    
    formatDuration(seconds) {
      const minutes = Math.floor(seconds / 60);
      return `${minutes}m`;
    }
  }
}
</script>

<style scoped>
.station-navigation {
  padding: 20px;
  background: white;
  border-bottom: 1px solid #e9ecef;
}

.section-title {
  font-size: 1em;
  font-weight: 600;
  color: #495057;
  margin: 0 0 15px 0;
}

.station-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.station-btn {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: left;
}

.station-btn:hover {
  background: #e9ecef;
  border-color: #adb5bd;
}

.station-btn.active {
  background: #007bff;
  border-color: #007bff;
  color: white;
}

.station-btn.completed {
  background: #d4edda;
  border-color: #c3e6cb;
}

.station-status {
  flex-shrink: 0;
}

.station-icon {
  font-size: 1.2em;
}

.station-details {
  flex: 1;
}

.station-name {
  font-weight: 500;
  font-size: 0.95em;
  margin-bottom: 2px;
}

.station-meta {
  font-size: 0.8em;
  opacity: 0.7;
}

.station-btn.active .station-meta {
  opacity: 0.9;
}
</style>